//组合redux子模块 + 导出store实例

import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./modules/user";
import projectReducer from './modules/project';
import agentReducer from './modules/agent';
import membershipReducer from './modules/membership';

export const store = configureStore({
    reducer: {
        user: userReducer,
        project: projectReducer,
        agent: agentReducer,
        membership: membershipReducer
    }
});

// 添加默认导出
export default store;
